// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__-B2ui","rootSuccess":"CompleteLink_rootSuccess__3Aphm","rootFailure":"CompleteLink_rootFailure__37lr1","isDisabled":"CompleteLink_isDisabled__3RKVm"};